import React from "react";
import CustomTable from "../components/CustomTable/CustomTable";

const customTableBasesLegais = (
  <CustomTable
    headers={["Finalidade tratamento", "Base legal aplicável"]}
    rows={[
      [
        "Identificar e autenticar você ao acessar a área do cliente ou realizar uma simulação",
        <>
          <b>Execução de contrato</b> (art. 7º, V, LGPD).
        </>,
      ],
      [
        "Oferecer cota de consórcio, analisar crédito, realizar contratação e cumprir obrigações contratuais",
        <>
          <b>Execução de contrato</b> (art. 7º, V, LGPD).
        </>,
      ],
      [
        "Cumprir obrigações legais e regulatórias relacionadas a consórcios, como normas do Bacen",
        <>
          <b>Cumprimento de obrigação legal ou regulatória</b> (art. 7º, II,
          LGPD).
        </>,
      ],
      [
        "Prevenir fraudes, garantir segurança e realizar validações cadastrais",
        <>
          <b>Legítimo interesse</b> (art. 7º, IX, LGPD), respeitados os direitos
          e liberdades fundamentais do titular.
        </>,
      ],
      [
        "Enviar comunicações de marketing e promoções personalizadas",
        <>
          <b>Consentimento</b> (art. 7º, I, LGPD).
        </>,
      ],
      [
        "Melhorar sua experiência nos sites e personalizar conteúdo com base em sua navegação",
        <>
          <b>Consentimento</b> (art. 7º, I, LGPD) obtido por meio do banner de
          cookies.
        </>,
      ],
      [
        "Atender suas solicitações de direitos como acesso, correção, oposição, exclusão ou portabilidade",
        <>
          <b>Cumprimento de obrigação legal</b> (art. 7º, II, LGPD).
        </>,
      ],
      [
        "Armazenar dados e documentos após a solicitação de exercício de direitos para fins de auditoria e defesa",
        <>
          <b>Legítimo interesse</b> (art. 7º, IX, LGPD), ou{" "}
          <b>Cumprimento de obrigação legal</b> (art. 7º, II, LGPD).
        </>,
      ],
      [
        "Compartilhar dados com parceiros, autoridades ou prestadores de serviço, quando necessário",
        <>
          <b>Execução de contrato, cumprimento de obrigação legal</b> ou{" "}
          <b>legítimo interesse</b>, conforme o caso.
        </>,
      ],
    ]}
  />
);

export const itensPoliticaPrivacidade = [
  {
    question: "A nossa privacidade é você!",
    answers: [
      {
        text: `
          Seja você um cliente de nossa empresa, alguém que tem 
          interesse em algum de nossos produtos e serviços ou apenas um 
          visitante em nossos sites, esse aviso se aplica a você.
        `,
        type: "default",
      },
    ],
    showDefault: true,
  },
  {
    question: "Qual é nossa responsabilidade?",
    answers: [
      {
        text: `
          Temos o compromisso de proteger seus dados pessoais de
          qualquer violação que exponha sua privacidade ou cause
          qualquer outro dano, utilizando os esforços necessários para
          controlar os riscos dessa violação de dados.`,
        type: "default",
      },
      {
        text: ` 
          Apesar
          desses esforços, eventualmente, podem ocorrer incidentes que
          envolvam seus dados pessoais. Nessas ocasiões seremos
          transparentes com você e com todos os órgãos reguladores sobre
          o que ocorreu.
        `,
        type: "default",
      }
    ],
    showDefault: true,
  },
  {
    question: "O que você precisa fazer?",
    answers: [
      {
        text: `
        O primeiro passo é que você leia atentamente este Aviso de
        Privacidade.
      `,
        type: "default",
      },
      {
        text: `
        Se já é cliente, é importante que verifique também o seu
        contrato e entenda como usamos as suas informações para
        fornecer os serviços ou os produtos que contratou. `,
        type: "default",
      },
      {
        text: `
        Ver Meus Produtos
      `,
        type: "link",
        link: "https://arealogada.caixaconsorcio.com.br/",
        target: "_blank",
      },
    ],
    showDefault: true,
  },
  {
    question: "Quem controla seus dados?",
    answers: [
      {
        text: `
          A CAIXA Consórcio, quando se relaciona diretamente com você e
          coleta suas informações, assume o papel de controlador dos
          seus dados pessoais, ou seja, define as finalidades do
          tratamento e como esses dados serão utilizados, conforme as
          nossas necessidades, mas sempre respeitando as bases legais
          vigentes e seus direitos. `,
        type: "default",
      },
    ],
    showDefault: true,
  },
  {
    question: "Como a gente recebe seus dados?",
    answers: [
      {
        text: `
          Podemos receber seus dados pessoais através de 2 formas:`,
        type: "default",
      },
      {
        text: `
          Dados fornecidos por você`,
        type: "bold",
      },
      {
        text: `
          Quando você nos fornece dados pessoais, preenchendo um
          formulário de cotação, por exemplo. Pode ser necessário que
          você informe seus dados pessoais quando preencher algum
          formulário, realizar a simulação de algum de nossos produtos
          ou para acessar nossas ofertas ou serviços. Veja abaixo
          quais são os dados pessoais que podemos solicitar.`,
        type: "default",
      },
      {
        text: `
          Para te identificar`,
        type: "bold",
      },
      {
        text: `
          CPF, RG, nome e sobrenome, naturalidade e nacionalidade,
          idade e data de nascimento e filiação.`,
        type: "default",
      },
      {
        text: `
          Para ter outras formas de falar com você`,
        type: "bold",
      },
      {
        text: `
          Seu endereço comercial e/ou residencial, endereço de e-mail
          e números de telefone (celular, comercial e fixo).`,
        type: "default",
      },
      {
        text: `
          Para disponibilizar produtos e serviços ou itens
          relacionados`,
        type: "bold",
      },
      {
        text: `
          Pedimos informações sobre sua renda e patrimônio, bem como de familiares,
          para processos de análise de crédito e para
          atendimento a leis e outros regulamentos, caso sejam
          aplicáveis aos produtos que você comprou com a gente.`,
        type: "default",
      },
      {
        text: `
          Informações bancárias também podem ser necessárias, para que
          você receba pagamentos dos produtos que tenha comprado ou
          para a gente pague algum valor que você tenha direito como
          devoluções e afins.`,
        type: "default",
      },
      {
        text: `
          Para a segurança de todos`,
        type: "bold",
      },
      {
        text: `
          Além das informações de usuário e senha para ter acesso a
          nossa área de clientes, podemos solicitar confirmação das
          informações indicadas acima, com o objetivo de identificar
          você unicamente em processos de verificação de ilícitos e
          validação de que você é você mesmo, visando evitar fraudes.`,
        type: "default",
      },
      {
        text: `
          Dados coletados durante nosso relacionamento`,
        type: "bold",
      },
      {
        text: `
          Dados importantes para melhorar sua experiência durante seu
          relacionamento com a gente.`,
        type: "default",
      },
      {
        text: `
          Coletamos seus dados quando você nos liga, quando compra
          algum produto em qualquer canal de venda ou em qualquer
          outro momento de nosso relacionamento. Nossas coletas de
          dados incluem:`,
        type: "default",
      },
      {
        text: `
          informações relacionadas ao histórico de seu
            relacionamento comercial conosco;`,
        type: "list",
      },
      {
        text: `
          pedidos de produtos e serviços, se aplicáveis, faturamento
          e pagamento;`,
        type: "list",
      },
      {
        text: `
          sua participação em ofertas promocionais, concursos ou
            eventos;`,
        type: "list",
      },
      {
        text: `
          solicitações suas ou imprevistos que você nos relatou, por
            exemplo, com relação à entrega de nossos produtos ou ao
            desempenho de nossos serviços;`,
        type: "list",
      },
      {
        text: `
          informações sobre compras de produtos e serviços que você
            realizou com nossos parceiros`,
        type: "list",
      },
      {
        text: `
          Quando você acessa nossos sites, observamos suas
          preferências de compras, seus interesses de serviços e seus
          dados e armazenamos essas informações no seu computador
          para que, quando você voltar, sua navegação fique mais
          prática e fácil. Fazemos isso através dos cookies. Para
          saber mais, conheça a nossa `,
        type: "default",
      },

      {
        text: `
        Política de Cookies
      `,
        type: "link",
        link: "#Políticadecookies",
      },
    ],
    showDefault: true,
  },
  {
    question: "Direito de crianças, adolescentes e pessoas incapazes",
    answers: [
      {
        text: `
          Não comercializamos nossos produtos e serviços diretamente
          para Crianças e/ou adolescentes e/ou pessoas consideradas
          incapazes nos termos da lei. `,
        type: "default",
      },
    ],
    showDefault: false,
  },
  {
    question: "Dados sensíveis",
    answers: [
      {
        text: `
          Os dados que são considerados sensíveis são: origem racial
          ou étnica, opiniões políticas, crenças religiosas ou
          filosóficas, associação a um sindicato, dados relacionados
          a saúde ou orientação sexual, além de dados biométricos ou
          genéticos. `,
        type: "default",
      },
      {
        text: `
          Não coletamos dados pessoais sensíveis na comercialização
          de nossos produtos e serviços. `,
        type: "default",
      },
    ],
    showDefault: false,
  },
  {
    question: "Para quê utilizamos seus dados?",
    answers: [
      {
        text: `
          Em nossos processos para disponibilizar produtos e
        serviços `,
        type: "bold",
      },
      {
        text: `
          Execução de contrato de nossos produtos e/ou serviços ou
        itens relacionados a esse contrato, como a cotação e
        aceite da contratação do consórcio; `,
        type: "list",
      },
      {
        text: `
          Pedidos de produtos ou serviços e execução desses pedido; `,
        type: "list",
      },
      {
        text: `
          Faturamento, cobrança de pagamentos; `,
        type: "list",
      },
      {
        text: `
          Relacionamento com o cliente por correio, telefone, e-mail
        ou mensagem instantânea como bate-papo, para qualquer
        pergunta, solicitação ou reclamação; `,
        type: "list",
      },
      {
        text: `
          Pesquisas de satisfação; `,
        type: "list",
      },
      {
        text: `
          Enviar informações sobre a manutenção ou a evolução de
        nossos serviços e produtos; `,
        type: "list",
      },
      {
        text: `
          Gerenciamento das suas escolhas e direitos quanto ao
        tratamento de seus dados pessoais. `,
        type: "list",
      },
      {
        text: `
          Em campanhas de marketing e prospecção comercial
        relacionadas a produtos e serviços da CAIXA Consórcio `,
        type: "bold",
      },
      {
        text: `
          Eventualmente nós vamos precisar enviar informações sobre
          nossa empresa, publicações e atividades, entendendo que
          essas informações atendem as suas expectativas. `,
        type: "default",
      },
      {
        text: `
          Vamos enviar também ofertas de marketing, publicidade e
        promoções relacionadas a nossos produtos e serviços por
        correio, e-mail, SMS, através de banners em sites ou nas
        redes sociais, sempre com a análise prévia de que você tem
        expectativa de receber essas comunicações. `,
        type: "default",
      },
      {
        text: `
          Podemos usar seus dados pessoais também para
        desenvolvimento de estatísticas comerciais, para melhorar
        os produtos e serviços que oferecemos e nossos canais de
        venda. `,
        type: "default",
      },
      {
        text: `
          Todas as vezes que a gente enviar uma comunicação para
        você, sempre vamos deixar disponível a opção de
        cancelamento do envio dessas informações e a exclusão
        delas de nossos sistemas.`,
        type: "default",
      },
    ],
    showDefault: false,
  },
  {
    question: "Parceiros que têm acesso aos seus dados",
    answers: [
      {
        text: `
          Alguns de nossos processos exigem a contratação de outras
        empresas para nos ajudar a executá-los. `,
        type: "default",
      },
      {
        text: `
          Para fornecer a você determinados serviços, podemos
        compartilhar seus dados pessoais com nossos parceiros de
        negócios, que realizam o tratamento dos seus dados de
        acordo com as nossas definições.`,
        type: "default",
      },
      {
        text: `
          Apesar desse acesso, os parceiros não podem usar os seus
        dados repassados para outros fins, somente para os que
        definimos. Essas definições estão dispostas em contratos,
        com responsabilidades e penalidades estabelecidas, para
        garantir que nenhum direito seu seja violado.`,
        type: "default",
      },
      {
        text: `
          Quando a nossa relação comercial com o parceiro o coloca
        no papel legal de controlador de dados pessoais, conforme
        a LGPD, esses parceiros têm autonomia para definir as
        finalidades de tratamento de seus dados pessoais. Nesses
        casos, nossos contratos com essas empresas garantem que
        nenhum de seus direitos será infringido, impondo
        obrigações e responsabilidades mútuas para segurança e
        proteção de suas informações.`,
        type: "default",
      },
      {
        text: `
          Para garantir que seus dados estão protegidos, parceiros e
        fornecedores críticos de nossa empresa passam por processo
        de gestão rígido, que contempla a avaliação e o
        acompanhamento periódicos, para garantir que estão
        seguindo todas as nossas políticas e as melhores práticas
        de segurança e governança. Garantimos também, por meio de
        contrato, que esses parceiros e fornecedores são
        responsáveis por qualquer violação de dados pessoais que
        tenham origem em sua estrutura.`,
        type: "default",
      },
      {
        text: `
          Para que você conheça mais sobre as categorias de nossos
        parceiros e fornecedores, as dividimos em: mão de obra
        especializada, infraestrutura e tecnologia e parceiros de
        negócio.`,
        type: "default",
      },
    ],
    showDefault: false,
  },
  {
    question: "Fornecedores de mão de obra especializada",
    answers: [
      {
        text: `
          Empresas que disponibilizam profissionais especializados
        para executar os mais diversos processos dentro da nossa
        empresa.`,
        type: "default",
      },
      {
        text: `
          Esses profissionais, assim como nossos funcionários,
          trabalham para entregar os serviços e os produtos a você,
          cuidam para atender às demandas regulatórias, ajudam na
          elaboração de peças para defesa em processos
          administrativos ou judiciais, além de acessarem suas
          informações para ofertar produtos e serviços.`,
        type: "default",
      },
    ],
    showDefault: false,
  },
  {
    question: "Fornecedores de infraestrutura e tecnologia",
    answers: [
      {
        text: `
          Os fornecedores são empresa ajudam a manter nosso ambiente
          operacional funcionando 24h, todos os dias, para atender
          as suas necessidades.`,
        type: "default",
      },
      {
        text: `
          Estão neste grupo de tecnologia empresas que realizam a
          manutenção e o fornecimento de servidores, sistemas,
          equipamentos de rede e armazenamento de dados em nuvem,
          incluídas também aquelas que nos auxiliam no monitoramento
          de nossos escritórios, principalmente no que diz respeito
          à segurança desses ambientes.`,
        type: "default",
      },
      {
        text: `
          A CAIXA Consórcio, para tratamento e segurança dos seus
        dados pessoais, formalizou acordo com a CNP Seguros
        Holding Brasil para utilização da estrutura de sistemas e
        tecnologias desta última, respeitando sempre as bases
        legais aplicáveis ao cumprimento do seu contrato e ao
        atendimento das disposições legais e regulatórias
        vigentes.`,
        type: "default",
      },
    ],
    showDefault: false,
  },
  {
    question: "Parceiros comerciais",
    answers: [
      {
        text: `
          Encaixam-se nessa categoria as empresas com as quais temos
        algum acordo operacional, para que participem da
        comercialização ou de parte do fornecimento de algum
        serviço ou produto que você contratou.`,
        type: "default",
      },
      {
        text: `
          No contexto da LGPD, para essa categoria, nem sempre o
        parceiro de negócio assume o papel de operador de dados
        pessoais, podendo, a depender da relação comercial e
        contratual conosco e com o titular dos dados, ser um
        controlador. Nesse caso, a CAIXA Consórcio pode assumir
        tanto o papel de operador ou de controlador, com as
        responsabilidades de cada organização, quanto à proteção
        de seus dados pessoais, sendo definidas e delimitadas em
        contrato.`,
        type: "default",
      },
    ],
    showDefault: false,
  },
  {
    question: "Onde armazenamos seus dados?",
    answers: [
      {
        text: `
          Quando recebemos ou coletamos suas informações, elas ficam
        armazenadas em sistemas e servidores que contam com
        políticas de segurança necessárias para impedir qualquer
        violação ou vazamento. Esses cuidados não extinguem a
        chance de um problema ocorrer, porém nossa intenção é
        reduzir riscos. `,
        type: "default",
      },
      {
        text: `
          Dependendo de cada empresa, utilizamos diversas
        tecnologias para armazenar seus dados, listadas a seguir.`,
        type: "default",
      },
      {
        text: (
          <>
            <b>Servidores alocados em parceiros</b>, com administração exclusiva
            nossa.
          </>
        ),
        type: "list",
      },
      {
        text: (
          <>
            <b>Servidores em nuvem</b>, administrados por nós, mas com a
            infraestrutura mantida por parceiros que possuem as mesmas garantias
            de segurança. Esses servidores podem estar em outros países. Para
            esses casos, garantimos contratualmente que nossos parceiros mantêm
            os dados exclusivamente em países com a mesma rigidez de controle de
            proteção de dados exigido pela nossa legislação.
          </>
        ),
        type: "list",
      },
      {
        text: (
          <>
            <b>Servidores de parceiros</b>, aadministrados por esses parceiros e
            monitorados por nós e com controles de segurança e proteção de dados
            garantidos por contratos.
          </>
        ),
        type: "list",
      },
    ],
    showDefault: false,
  },
  {
    question: "Por quanto tempo armazenamos seus dados?",
    answers: [
      {
        text: `
          Guardamos os dados que você nos fornece ou que coletamos
        durante nosso relacionamento comercial para atender a
        nossos reguladores e às legislações aplicáveis a cada
        produto oferecido por nossa empresa. A definição do
        período de armazenamento de seus dados para esse tipo de
        finalidade é definida por cada regulador.`,
        type: "default",
      },
      {
        text: `
          Além disso, é importante ressaltar que, a qualquer
        momento, em nosso Portal de Privacidade, na seção Seus
        Direitos, ou em nosso Serviços de Atendimento ao Cliente
        (0800 975 1000), você pode registrar sua solicitação de
        oposição a algum dos tratamentos de dados que realizamos.`,
        type: "default",
      },
    ],
    showDefault: false,
  },
  {
    question: "Como seus dados são protegidos?",
    answers: [
      {
        text: `
          Nós temos uma Política de Segurança de Informação rígida
        que prevê todos os cuidados para que suas informações
        estejam seguras pelo período que for necessário mantê-las.`,
        type: "default",
      },
      {
        text: `
          Trabalhamos para proteger os seus dados contra destruição
        ou alteração acidental ou ilegal, perda acidental,
        divulgação ou acesso não autorizado e contra outras formas
        ilegais de tratamento de dados pessoais e sensíveis.`,
        type: "default",
      },
      {
        text: `
          Além disso, nos preocupamos em:`,
        type: "default",
      },
      {
        text: (
          <>
            <b>
              coletar e tratar apenas dados pessoais adequados, relevantes e não
              excessivos, conforme necessário para atender aos objetivos e às
              finalidades definidas ou que estejam dentro de suas expectativas;
            </b>
          </>
        ),
        type: "list",
      },
      {
        text: (
          <>
            <b>
              garantir que seus dados pessoais permaneçam íntegros. Para isso,
              podemos solicitar que você confirme os dados pessoais que mantemos
              sobre você. E, sempre que houver alguma mudança no seu contexto
              pessoal, pedimos que nos seja comunicado para mantermos seus dados
              sempre atualizados.
            </b>
          </>
        ),
        type: "list",
      },
    ],
    showDefault: false,
  },
  {
    question: "Bases legais aplicadas por finalidade de tratamento",
    answers: [
      {
        text: customTableBasesLegais,
        type: "default",
      },
    ],
    showDefault: false,
  },
];
